import ThousandsFormat from "./thousandsFormat";

export function currencyThousandFormat(value: string | number) {
  const numberAsString = typeof value === "number" ? value : parseFloat(value);
  return "€\u00A0" + ThousandsFormat(numberAsString);
}

export function currencyFormat(value: string | number) {
  const numberAsString = typeof value === "number" ? value.toFixed(2) : parseFloat(value).toFixed(2);

  const formattedValue = numberAsString.replace(".", ",");
  return "€\u00A0" + formattedValue;
}
